import { Provider } from '@angular/core';

import { CustomAngularPlugin } from '../plugins';
import { AngularPluginRouter } from '../services';

export function provideAppInsightsCustomAngularPlugin(): Provider[] {
  return [AngularPluginRouter, CustomAngularPlugin];
}
